import {
  store,
  convertOrderItemsToBuyXFreeX,
  foodSidebarScrollToButtom
} from "@redux"
import ObjectValues from "./ObjectValues"

const setOrderContents = (matchedBuyXFreeXCombo) => {
  const {
    order: { items: orderItems }
  } = store.getState()

  const buyXFreeXComboItemsMap = {}
  matchedBuyXFreeXCombo.comboSets.forEach((set) => {
    set.items.forEach(item => {
      buyXFreeXComboItemsMap[item.optionId] = {
        _id: item._id,
        comboSetItemId: item._id,
        quantity: set.isFixed ? item.quantity : set.maxQty,
        addAmount: item.addAmount
      }
    })
  })

  let totalItemsSalePrice = 0
  let totalAddedAmount = 0

  const comboItemsMap = {}
  const removeOrderItemIds = {}
  const updateOrderItemsIds = {}

  // extract combo items and find order items that need to be changed or removed from cart
  orderItems.forEach(orderItem => {
    if (!buyXFreeXComboItemsMap[orderItem.optionId]) return

    const buyXFreeXComboItem =
      buyXFreeXComboItemsMap[orderItem.optionId]

    const orderItemFinalPrice =
      orderItem.salePrice +
      buyXFreeXComboItem.addAmount

    const residue =
      orderItem.quantity -
      buyXFreeXComboItem.quantity

    if (residue === 0) {
      removeOrderItemIds[orderItem.orderItemId] = true

      totalItemsSalePrice +=
        orderItemFinalPrice *
        orderItem.quantity

      totalAddedAmount +=
        buyXFreeXComboItem.addAmount *
        orderItem.quantity

      comboItemsMap[orderItem.optionId] =
        !!comboItemsMap[orderItem.optionId] ? {
          ...comboItemsMap[orderItem.optionId],
          quantity:
            comboItemsMap[orderItem.optionId].quantity +
            orderItem.quantity
        } : {
          _id: buyXFreeXComboItem._id,
          comboSetItemId: buyXFreeXComboItem.comboSetItemId,
          foodId: orderItem.foodId,
          isSimple: orderItem.isSimple,
          foodImageCover: orderItem.foodImageCover,
          foodName: orderItem.foodName,
          addAmount: buyXFreeXComboItem.addAmount,
          optionId: orderItem.optionId,
          optionName: orderItem.optionName,
          salePrice: orderItem.salePrice,
          quantity: orderItem.quantity,
          taxItems: orderItem.taxItems
        }

      return
    }

    if (residue > 0) {
      updateOrderItemsIds[orderItem.orderItemId] = residue

      totalItemsSalePrice +=
        orderItemFinalPrice *
        buyXFreeXComboItem.quantity

      totalAddedAmount +=
        buyXFreeXComboItem.addAmount *
        buyXFreeXComboItem.quantity

      comboItemsMap[orderItem.optionId] =
        !!comboItemsMap[orderItem.optionId] ? {
          ...comboItemsMap[orderItem.optionId],
          quantity: comboItemsMap[orderItem.optionId].quantity + residue
        } : {
          _id: buyXFreeXComboItem._id,
          comboSetItemId: buyXFreeXComboItem.comboSetItemId,
          foodId: orderItem.foodId,
          isSimple: orderItem.isSimple,
          foodImageCover: orderItem.foodImageCover,
          foodName: orderItem.foodName,
          addAmount: buyXFreeXComboItem.addAmount,
          optionId: orderItem.optionId,
          optionName: orderItem.optionName,
          salePrice: orderItem.salePrice,
          quantity: buyXFreeXComboItem.quantity,
          taxItems: orderItem.taxItems
        }

      return
    }

    if (residue < 0) {
      removeOrderItemIds[orderItem.orderItemId] = true

      totalItemsSalePrice +=
        orderItemFinalPrice *
        orderItem.quantity

      totalAddedAmount +=
        buyXFreeXComboItem.addAmount *
        orderItem.quantity

      buyXFreeXComboItemsMap[orderItem.optionId].quantity = -residue

      comboItemsMap[orderItem.optionId] =
        !!comboItemsMap[orderItem.optionId] ? {
          ...comboItemsMap[orderItem.optionId],
          quantity:
            comboItemsMap[orderItem.optionId].quantity +
            orderItem.quantity
        } : {
          _id: buyXFreeXComboItem._id,
          comboSetItemId: buyXFreeXComboItem.comboSetItemId,
          foodId: orderItem.foodId,
          isSimple: orderItem.isSimple,
          foodImageCover: orderItem.foodImageCover,
          foodName: orderItem.foodName,
          addAmount: buyXFreeXComboItem.addAmount,
          optionId: orderItem.optionId,
          optionName: orderItem.optionName,
          salePrice: orderItem.salePrice,
          quantity: orderItem.quantity,
          taxItems: orderItem.taxItems
        }

      return
    }
  })

  const comboSetSalePrice =
    matchedBuyXFreeXCombo.comboSetSalePrice +
    totalAddedAmount

  const comboDiscount =
    totalItemsSalePrice -
    comboSetSalePrice

  const items = ObjectValues(comboItemsMap)

  const newCombo = {
    items,
    name: matchedBuyXFreeXCombo.name,
    code: matchedBuyXFreeXCombo.code,
    comboSetSalePrice,
    totalItemsSalePrice,
    comboDiscount
  }

  store.dispatch(
    convertOrderItemsToBuyXFreeX(
      newCombo,
      removeOrderItemIds,
      updateOrderItemsIds
    )
  )

  store.dispatch(
    foodSidebarScrollToButtom()
  )
}

const findMatchableBuyXFreeX = (buyXFreeXCombos, orderOptionIdsMap) => {
  const matchedBuyXFreeXCombo =
    buyXFreeXCombos.find(buyXFreeXCombo => {
      let isMatch = true

      buyXFreeXCombo.comboSets.forEach(set => {
        if (!isMatch) return

        if (set.isFixed) {
          set.items.forEach(item => {
            if (orderOptionIdsMap[item.optionId] !== item.quantity)
              isMatch = false
          })
        } else {
          let total = 0

          set.items.forEach(item => {
            if (!orderOptionIdsMap[item.optionId]) return

            total += orderOptionIdsMap[item.optionId]
          })

          if (total < set.maxQty) isMatch = false
        }
      })

      return isMatch
    })

  return matchedBuyXFreeXCombo
}

const isConvertibleToBuyXFreeX = () => {
  const {
    order: { items: orderItems },
    combos
  } = store.getState()

  // filter order items that have specification their price has been changed
  const filteredOrderItems =
    orderItems.filter(orderItem =>
      orderItem.systemDiscount === 0 &&
      orderItem.specificationItems.length === 0
    )

  if (filteredOrderItems.length === 0) return

  const buyXFreeXCombos =
    combos.filter(combo => combo.isBuyxFreeX)

  if (buyXFreeXCombos.length === 0) return

  // Map order items base on option id as key and quantity as value
  const orderOptionIdsMap = {}
  filteredOrderItems.forEach(orderItem => {
    const exists = !!orderOptionIdsMap[orderItem.optionId]

    if (exists)
      orderOptionIdsMap[orderItem.optionId] += orderItem.quantity
    else
      orderOptionIdsMap[orderItem.optionId] = orderItem.quantity
  })

  const matchedBuyXFreeXCombo =
    findMatchableBuyXFreeX(
      buyXFreeXCombos,
      orderOptionIdsMap
    )

  if (!matchedBuyXFreeXCombo) return

  setOrderContents(matchedBuyXFreeXCombo)
}

export default isConvertibleToBuyXFreeX